import { globalErrorMsg } from '@bingads-webui-campaign/hotel-common-upsert';
import { validateBidAdjustment, isValueOverlap } from '../components/utility';
import { validateAdvancedBookingDays } from './utility';

export function getAbwBasicConfig(i18n) {
  const columns = [
    {
      key: 'minimum-days', name: i18n.getString(_TL_('Minimum days')), fieldName: 'minimumDays', minWidth: 100, maxWidth: 117, type: 'input', className: 'border-right', headerClassName: 'target-custom-header',
    },
    {
      key: 'maximum-days', name: i18n.getString(_TL_('Maximum days')), fieldName: 'maximumDays', minWidth: 100, maxWidth: 127, type: 'input', className: 'border-right', headerClassName: 'target-custom-header',
    },
  ];
  return {
    basicConfig: {
      columns,
      showAddBtn: true,
      showSettingToggle: true,
      titleKey: i18n.getString(_TL_('Advanced booking window')),
      topicKey: 'pop_BA_CampaignTargets_AdvancedBookingWindow',
      maxLimit: 10,
      minBid: -90,
      maxBid: 900,
      extraBid: [-100],
    },
  };
}


export const advancedBookingDefaultSetting = [{
  minimumDays: '',
  maximumDays: '',
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
}];

export const isABWTargetValid = (ABW, patchErrMsg = function () { }) => {
  let isValid = true;
  ABW.filter(item => item.Status !== 'Deleted').forEach((item) => {
    let validateValue = item.bidAdjustmentInput;
    if (item.bidAdjustmentDropdown === 'Decrease by') {
      validateValue = -validateValue;
    }
    if (validateBidAdjustment({
      value: validateValue, min: -90, max: 900, extra: [-100],
    }) || validateAdvancedBookingDays({ value: item.minimumDays }) || validateAdvancedBookingDays({ value: item.maximumDays })) {
      isValid = false;
    }
  });
  if (isValueOverlap('ABW', ABW)) {
    isValid = false;
  }

  if (isValid) {
    patchErrMsg('ABW', '');
  } else {
    patchErrMsg('ABW', globalErrorMsg);
  }
  return isValid;
};

